/**
 * Returns the `backward_data` object passed via React Router's location state
 * from a NeoImporter `backwardCallback`.
 *
 * @param {Object} location - React Router location object (props.location).
 * @returns {Object|null} The raw backward_data, or null if not present.
 */
export default function useBackwardData(location) {
    return location && location.state ? location.state.backward_data || null : null;
}
